import React, {useEffect, useRef, useCallback} from 'react';
import {
  View,
  Animated,
  Image,
  Easing,
  useWindowDimensions,
  ViewStyle,
  ImageStyle,
} from 'react-native';

import {v4 as uuid} from 'uuid';

import {spacing} from 'theme/Units';
import { mergeDeepRight } from 'ramda';

export default function Marquee(): JSX.Element {

  // animation logic
  const translateX = useRef(new Animated.Value(0)).current;
  // Function to start animation
  const startAnimation = useCallback(() => {
    translateX.setValue(0);
    Animated.timing(translateX, {
      toValue: -1200,
      duration: 10000,
      useNativeDriver: true,
      easing: Easing.linear,
    }).start(() => startAnimation());
  }, [translateX]);

  useEffect(() => {
    startAnimation();
  }, [startAnimation]);

  // max number of images instance on the screen (changes according to device width)
  let numberImageOfInstances = 30;

  // responsiveness logic
  const overridestyle = structuredClone(baseStyles);
  const {width: SCREEN_WIDTH} = useWindowDimensions();

  // break points and styling
  if (SCREEN_WIDTH < 1024) {
    overridestyle.container.paddingVertical = spacing['10'];
    overridestyle.waterMarkLogo.width = 144;
    overridestyle.waterMarkLogo.height = 82;
    overridestyle.animatedContainer.gap = spacing['12'];
  }
  if (SCREEN_WIDTH < 720) {
    overridestyle.container.paddingVertical = spacing['8'];
    overridestyle.waterMarkLogo.width = 112;
    overridestyle.waterMarkLogo.height = 64;
    overridestyle.animatedContainer.gap = spacing['10'];
  }
  if (SCREEN_WIDTH < 640) {
    overridestyle.container.paddingVertical = spacing['6'];
    overridestyle.waterMarkLogo.width = 86;
    overridestyle.waterMarkLogo.height = 46;
    overridestyle.animatedContainer.gap = spacing['8'];
  }
  if (SCREEN_WIDTH < 480) {
    overridestyle.container.paddingVertical = spacing['4'];
    overridestyle.waterMarkLogo.width = 54;
    overridestyle.waterMarkLogo.height = 28;
    overridestyle.animatedContainer.gap = spacing['6'];
  }
  if (SCREEN_WIDTH < 360) {
    overridestyle.container.paddingVertical = spacing['2'];
    overridestyle.waterMarkLogo.width = 36;
    overridestyle.waterMarkLogo.height = 24;
  }

  // styls merging
  const styles: styleType = mergeDeepRight(baseStyles, overridestyle) as any;

  return (
    <View style={styles.container}>
      <Animated.View
        style={[
          styles.animatedContainer,
          {
            transform: [{translateX}],
          },
        ]}>
        {/* Render multiple images for smooth looping */}
        {Array(numberImageOfInstances)
          .fill(0)
          .map(_ => (
            <Image
              key={uuid()}
              source={require('assets/images/watermark_digital.png')}
              style={styles.waterMarkLogo}
            />
          ))}
      </Animated.View>
    </View>
  );
}

type styleType = {
  container: ViewStyle;
  waterMarkLogo: ImageStyle;
  animatedContainer: ViewStyle;
};

const baseStyles: styleType = {
  container: {
    paddingVertical: spacing['12'],
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  animatedContainer: {
    flexDirection: 'row',
    gap: spacing['16'],
  },
  waterMarkLogo: {
    width: 182,
    height: 100,
    resizeMode: 'contain',
  },
};
